import { IDropdownOption } from 'office-ui-fabric-react';
import store from 'configureStore';
import { ITransportType } from '../reducer/user';

export const capacity: { [key: string]: string } = {
  МК: 'МК - Малый класс',
  СК: 'СК - Средний класс',
  БК: 'БК - Большой класс',
  ОБК: 'ОБК - Особо большой класс',
};

export const dropdownOptionsCapacity: IDropdownOption[] = [
  { key: 'МК', text: 'МК - Малый класс' },
  { key: 'СК', text: 'СК - Средний класс' },
  { key: 'БК', text: 'БК - Большой класс' },
  { key: 'ОБК', text: 'ОБК - Особо большой класс' },
];

export const setRouteTypeColors = () => {
  let routeTypeColors: { [key: string]: string } = {};
  store.getState().user.transporttypes.forEach((transport: ITransportType) => {
    routeTypeColors[transport.code] = transport.color;
  });
  return routeTypeColors;
};

// export const routeTypeColors: { [key: string]: string } = {
//   А: '#0078D4',
//   Тб: '#7FBA00',
//   Тм: '#FF0000',
//   Аэ: '#9730FF',
// };

export const routeTypeColors: { [key: string]: string } = setRouteTypeColors();

export const setRouteTypes = () => {
  let routeTypes: { [key: string]: string } = {};
  store.getState().user.transporttypes.forEach((transport: ITransportType) => {
    routeTypes[transport.code] = transport.title;
  });
  return routeTypes;
};

// export const routeTypes: { [key: string]: string } = {
//   А: 'Автобус',
//   Тб: 'Троллейбус',
//   Тм: 'Трамвай',
//   Аэ: 'Автобус с электрическим двигателем',
// };

export const routeTypes: { [key: string]: string } = setRouteTypes();

export const setDropdownOptionsRouteTypes = () => {
  let dropdownOptionsRouteTypes: IDropdownOption[] = [];
  store.getState().user.transporttypes.forEach((transport: ITransportType) => {
    dropdownOptionsRouteTypes.push({
      key: transport.code,
      text: transport.title,
    });
  });
  return dropdownOptionsRouteTypes;
};

// export const routeTypesAsDropdownOptions: IDropdownOption[] = [
//   { key: 'А', text: 'Автобус' },
//   { key: 'Тб', text: 'Троллейбус' },
//   { key: 'Тм', text: 'Трамвай' },
//   { key: 'Аэ', text: 'Автобус с электрическим двигателем' },
// ];

export const dowsTypes: { [key: number]: string; [key: string]: string } = {
  10: 'Рабочие',
  11: 'Выходные',
  9: 'Все',
};

export const dropdownOptionsRouteTypes: IDropdownOption[] = setDropdownOptionsRouteTypes();

export const translatedTerms: { [key: string]: string } = {
  branch: 'Предприятие',
  depot: 'Филиал',
  route: 'Маршрут',
  depotNumber: 'Гаражный номер',
  date: 'Дата',
  role: 'Роль',
  user: 'Пользователь',
  type: 'Тип видео',
  stop_id: 'ОП',
  capacity: 'Вместимость',
  route_type: 'Вид ТС',
  reqnumber: 'Номер заявки',
  direction: 'Направление',
  status: 'Состояние видеофрагмента',
  startDate: 'Дата начала',
  endDate: 'Дата окончания',
  name: 'Наименование',
  pas_status: 'Статус',
  routeType: 'Вид ТС',
  percent: 'Процент выполнения',
  selectedRoutes: 'Маршрут',
  selectedStops: 'Остановочный пункт',
  selectedHours: 'Часы',
  selectedDows: 'Дни недели',
  selectedTicketType: 'Тип билета',
  selectedBranches: 'Предприятие',
  selectedDepots: 'Филиал',
  selectedVehicleDepotNums: 'Гаражный номер',
  dowsTypes: 'Тип дня недели',
  interval: 'Интервал',
  grafic: '№ выхода'
};

export const translatedRoutesParams: { [key: string]: string } = {
  route_short_name: 'Краткое наименование',
  route_long_name: 'Полное наименование',
  route_desc: 'Описание',
  reg_num: 'Регистрационный номер',
  route_type: 'Тип маршрута',
  route_view: 'Вид маршрута',
};

export const translatedStopsParams: { [key: string]: string } = {
  building_address: 'Адрес ОП',
  location_type: 'Тип локации',
  pavilion: 'Павильон',
  stop_name: 'Наименование ОП',
  stop_pavilion_balance_organizations: 'Эксплуатирующая организация',
  street: 'Улица',
  stop_code: 'Краткое наименование',
  stop_desc: 'Описание',
  region: 'Район',
  district: 'Округ',
};

export const PdmIndicatorsList = {
  '/pdm/heatmap': undefined,
  '/pdm/tree-editor': ['ust-changed'],
  '/pdm/charts': undefined,
  '/pdm/equipment-status-report': undefined,
}
